import { DateTime } from "luxon";

const mutations = {
		addProblem(state, problem) {
			state.form.problems.push(problem)
		},
		deleteProblem(state, problemIdentifier) {
			state.form.problems = state.form.problems.filter(problem => !(problem.problem.id == problemIdentifier.problemId && problem.person.id == problemIdentifier.personId))
		},
		setUsername(state, username) {
			state.username = username
		},
		setForm(state, form) {
			Object.keys(form).forEach(element => state.form[element] = form[element])
		},
		setFormProperty(state, { property, value }) {
			state.form[property] = value
		},
		setFormId(state, formId) {
			state.formId = formId
		}
	}

const getters = {
	formAlreadyLoaded: state => state.formId != ''
}

export default  class StoreDefinition  {
	definition = {
		state: {
			formId: '',
			username: '',
			form: {
				user: '',
				reportTime: DateTime.local().toFormat('yyyy-MM-dd HH:mm'),
				endReportTime: DateTime.local().toFormat('yyyy-MM-dd HH:mm'),
				type: 'adequate',
				age: '',
				sex: '',
				callFrequency: '',
				callerDescription: '',
				firstSentences: '',
				shortContent: '',
				helperDescriptions: '',
				problems: [],
				expectations: [],
				relationLevel: [],
				actions: [],
				therapies: [],
				collaboration: '',
				efficiency: '',
				callerSatisfied: '',
				helperSatisfied: '',
				maritalState: '',
				profession: '',
				publicCared: '',
				childrenNumber: null,
				orderInSiblings: null,
				siblingsNumber: null,
				divorceCount: null,
				crisis: false,
				suicide: false,
				covid: false,
				inadequateCallType: ''
			}
		},
		mutations, getters
	}
}